require('../../modules/es6.math.trunc');
module.exports = require('../../modules/_core').Math.trunc;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/trunc.js
// module id = 1057
// module chunks = 61